import React, { useRef, useEffect, useState } from 'react';
// import { CardAction } from 'src/components/common/Card.redesign';
import { SelectItem } from 'src/models/common/SelectItem';
import Ownership from 'src/models/tract_detail/Ownership';
import Owner from 'src/models/tract_detail/Owner';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import FormTextbox, { FormTextBoxDataType } from 'src/components/controls/forms/redesign/FormTextbox';
import { TweenLite } from 'gsap';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import AddressUtil from 'src/util/Address';
import AdditionOwnershipType from 'src/models/tract_detail/AdditionalOwnershipType';
import ContextMenu, { ContextMenuAction } from 'src/components/common/ContextMenu';
import * as Constants from 'src/components/common/Constants';
import { convertInstrumentTypesToSelectList } from 'src/models/InstrumentType';
import { OwnershipCategoryType } from 'src/models/OwnershipCategory';

interface IAdditionalOwnershipCardProps {
    isHighlighted?: boolean;
    badgeStyle?: React.CSSProperties;
    badge?: string;
    infoBar?: string | React.ReactElement;
    actions?: Array<ContextMenuAction>;
    rightBadgePanel?: string | React.ReactElement;
    contactCategories: Array<SelectItem>;
    categoryTypes: Array<OwnershipCategoryType>;
    additionalOwnership: Ownership;
    leaseBuyers: Array<SelectItem>;
    additionalOwner: Owner;
    parentIndex: number;
    index: number;
    hasNonExecutiveAdditionalOwnership: boolean;
    onInterestChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onInterestFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
    isCommittedCategoriesHidden: boolean;
}

const AdditionalOwnershipCard = (props: IAdditionalOwnershipCardProps) => {
    const popupEl = useRef(null);
    const [contextMenuShowing, setContextMenuShowing] = useState(false);
    const [localContactCategories, setLocalContactCategories] = useState<Array<SelectItem>>(undefined);

    // let cardClassName = 'dlc-card';
    // cardClassName += props.badge || props.rightBadgePanel ? ` has-badge` : '';
    // cardClassName += (props.actions && props.actions.length > 0) ? ` has-actions` : '';

    /* Runs once on mount rather than on every render. The popup this targets is
       currently commented out below, so popupEl.current is null and the tween never
       fires - but without a dependency array React still re-invoked this for every
       card on every render pass. */
    useEffect(() => {
        if (popupEl.current) {
            TweenLite.to(popupEl.current, 0, { height: '2rem', width: '1.7rem', opacity: '0', pointerEvents: 'none' });
        }
    }, []);

    useEffect(() => {
            setLocalContactCategories(props?.contactCategories?.filter((type: SelectItem) =>
                props?.isCommittedCategoriesHidden  && type?.id !== props?.additionalOwnership?.ownershipContactCategoryId ? !type?.name?.includes('Committed') : true
            ));
        }, [props.contactCategories]);

    // const togglePopup = (state: boolean) => {
    //     if (state) {
    //         TweenLite.to(popupEl.current, 0.2, { height: 'auto', width: 'auto', opacity: '1', pointerEvents: 'inherit' });
    //     } else {
    //         TweenLite.to(popupEl.current, 0.2, { height: '2rem', width: '1.7rem', opacity: '0', pointerEvents: 'none' });
    //     }
    //     setActionMenuShowing(state);
    // };

    // const clickAction = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, action: CardAction) => {
    //     event.stopPropagation();
    //     action.action();
    // };

    const determineOwnerType = (id: number) => {
        let type = 'Unknown';
        switch (id) {
            case 1:
                type = 'Heir';
                break;
            case 2:
                type = 'Remainderman';
                break;
            case 3:
                type = 'Non-Executive';
                break;
            case 4:
                type = 'Non-Participating';
                break;
            case 5:
                type = 'Transfer On Death';
                break;
            case 6:
                type = 'Naked Owner';
                break;
            default:
                break;
        }

        return type;
    };

    const focusChangeEvent = (additionalOwnershipTypeId: number, isChange: boolean) => {
        const type = determineOwnerType(additionalOwnershipTypeId).toLowerCase();
        if (type === 'non-executive' || type === 'heir') {
            return isChange ? props.onInterestChange : props.onInterestFocus;
        } else {
            return undefined;
        }
    };

    const netAcresPanel = () => {
        if (
            props.additionalOwnership.additionalOwnershipTypeId === AdditionOwnershipType.NakedOwner ||
            props.additionalOwnership.additionalOwnershipTypeId === AdditionOwnershipType.TransferOnDeath ||
            props.additionalOwnership.additionalOwnershipTypeId === AdditionOwnershipType.Remainderman ||
            props.additionalOwnership.additionalOwnershipTypeId === AdditionOwnershipType.NonParticipating
        ) {
            return <div style={{ width: '15.8rem' }} />;
        } else {
            return (
                <div>
                    <FormTextbox
                        label="Net Acres"
                        name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].netAcres`}
                        onChange={() => focusChangeEvent(props.additionalOwnership.additionalOwnershipTypeId, true)}
                        onFocus={() => focusChangeEvent(props.additionalOwnership.additionalOwnershipTypeId, false)}
                        type={FormTextBoxDataType.Float}
                    />
                </div>
            );
        }
    };

    const isClientLeased = (): boolean => {
        return props?.additionalOwnership?.isWIClientAcreage;
    };
    
    const handleCategoryOptions = (typeId: number) => {
        let catType = props.categoryTypes?.find(ct => ct.id === typeId);

        return catType?.selections?.map(s => new SelectItem(s.id, s.text)) ?? [];
    };

    return (
        <div
            key={props.additionalOwnership.id}
            className="additional-ownership"
            onMouseEnter={() => setContextMenuShowing(true)}
            onMouseLeave={() => setContextMenuShowing(false)}
            style={{ display: 'block', padding: 0, border: '1px solid lightgrey' }}
        >
            <div className="card-header-row">
                <div className="left-info-badge">
                    <div className="badge">
                        {props.badge && (
                            <p className="badge-content" style={props.badgeStyle}>
                                {props.badge}
                            </p>
                        )}
                    </div>
                    <div className="info-bar">
                        {props.infoBar && props.isHighlighted &&
                            <span style={{ background: 'yellow', border: '.5px solid gray', borderRadius: '5%' }}>
                                &nbsp;{props.infoBar}&nbsp;
                            </span>}
                        {props.infoBar && !props.isHighlighted &&
                            <span style={{ margin: '0' }}>
                                {props.infoBar}
                            </span>}
                    </div>
                </div>
                <div className="right-info-badge" style={{ gap: '1rem' }}>
                    {props.rightBadgePanel && <span className="right-info-badge-content">{props.rightBadgePanel}</span>}
                    <ContextMenu actions={props.actions} isVisible={contextMenuShowing} />
                </div>
            </div>
            <br />
            <div style={{ minHeight: '5rem', margin: '0rem 1rem 0 1rem', display: 'flex', justifyContent: 'space-between' }}>
                {props.additionalOwner && (
                    <div style={{ gap: '1rem', display: 'inline', maxWidth: '20%', paddingRight: '0.5rem' }}>
                        {props.additionalOwner.name} - {determineOwnerType(props.additionalOwnership.additionalOwnershipTypeId)} {props.additionalOwnership.npriStatus ?? ''}
                        <div style={{ fontSize: '1.4rem' }}>
                            {AddressUtil.concatWithCommas(
                                props.additionalOwner.addressLine1,
                                props.additionalOwner.city,
                                props.additionalOwner.state
                            )}
                        </div>
                    </div>
                )}
                <div style={{ display: 'none' }}>
                    <FormTextBox label="NOSHOW" name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].id`} />
                    <FormTextBox label="NOSHOW" name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].parentOwnershipId`} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="mr-1">
                        <FormTextbox
                            label="Vesting Deed Reference"
                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].vestingDeedReference`}
                            style={{ minWidth: '23rem' }}
                        />
                        <FormTextbox
                            label="Vesting Deed Date"
                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].vestingDeedDate`}
                            type={FormTextBoxDataType.Date}
                        />
                    </div>
                    <div className="mr-1">
                        <FormSelect
                            label="Vesting Deed Instrument Type"
                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].vestingDeedInstrumentType`}
                            items={convertInstrumentTypesToSelectList()}
                            style={{ minWidth: '23rem' }}

                        />
                        <FormTextbox
                            label="Vesting Deed Instrument Source"
                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].vestingDeedInstrumentSource`}
                        />
                    </div>
                    <div className="mr-1">
                        {props.additionalOwnership.ownershipCategories?.map((oc, index) => {
                            return (
                                <div key={`ownershipCategory-${index}`} className="mr-1" style={{ width: '23rem' }}>
                                    <div hidden={true}>
                                        <FormTextbox
                                            label="NOSHOW"
                                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].ownershipCategories[${index}].id`}
                                            type={FormTextBoxDataType.Int}
                                        />
                                        <FormTextbox
                                            label="NOSHOW"
                                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].ownershipCategories[${index}].ownershipId`}
                                            type={FormTextBoxDataType.Int}
                                        />
                                        <FormTextbox
                                            label="NOSHOW"
                                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].ownershipCategories[${index}].categoryTypeId`}
                                            type={FormTextBoxDataType.Int}
                                        />
                                    </div>
                                    <FormSelect
                                        label={oc.categoryTypeName}
                                        name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].ownershipCategories[${index}].categorySelectionId`}
                                        items={handleCategoryOptions(oc.categoryTypeId)}
                                        style={{ minWidth: '23rem' }}
                                    />
                                </div>
                            );
                        })}
                        <FormSelect
                            label="Contact Category"
                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].ownershipContactCategoryId`}
                            items={localContactCategories}
                            style={{ minWidth: '23rem' }}
                        />
                        <FormSelect
                            label="Lease Buyer"
                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].leaseBuyer`}
                            items={props.leaseBuyers}
                        />
                    </div>
                    <div style={{ display: 'none' }}>
                        <FormTextbox
                            label="NOSHOW"
                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].id`}
                            type={FormTextBoxDataType.Int}
                        />
                    </div>
                    {props.hasNonExecutiveAdditionalOwnership && (
                        <div className="mr-1">
                            <FormTextbox
                                label="Executive Rights"
                                onFocus={props.onInterestFocus}
                                onChange={props.onInterestChange}
                                name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].executiveRights`}
                                type={FormTextBoxDataType.Float}
                            />
                        </div>
                    )}
                    <div className="mr-1">
                        <FormTextbox
                            label="Interest"
                            name={`ownerships[${props.parentIndex}].additionalOwnerships[${props.index}].decimalInterest`}
                            onChange={() => focusChangeEvent(props.additionalOwnership.additionalOwnershipTypeId, true)}
                            onFocus={() => focusChangeEvent(props.additionalOwnership.additionalOwnershipTypeId, false)}
                            type={FormTextBoxDataType.Float}
                            isHighlighted={isClientLeased() && props?.additionalOwnership?.leasedStatus !== Constants.contractStatus.OPEN}
                        />
                    </div>
                    <div>
                        {netAcresPanel()}
                    </div>
                </div>
            </div>
            {/* <>
                <div className="actions-panel"><span className="options-button" onMouseOver={() => togglePopup(true)} /></div>
                <div className="actions-popup-mask" ref={popupEl} onMouseLeave={() => togglePopup(false)}>
                    <div className="actions-popup">
                        <div className="actions-popup-header">Options</div>
                        {props.actions.map((action: CardAction, index: number) =>
                            <div className="action" key={index} onClick={(e) => clickAction(e, action)} style={{ width: '14rem', minHeight: '2.5rem' }}>
                                {action.text}
                            </div>
                        )}
                    </div>
                </div>
            </> */}
        </div>
    );
};

export default AdditionalOwnershipCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/AdditionalOwnershipCard.tsx